export default __webpack_public_path__ + "static/media/ckad.1144d9c0.png";